import { Tab } from 'entities/Tab/interfaces';

export const tabs: Tab[] = [
  {
    id: 'tripsData',
    href: '/ordering',
    title: 'Список рейсів на завантаження',
  },
  {
    id: 'unloadTripsData',
    href: '/ordering/unload',
    title: 'Список рейсів на розвантаження',
  },
  {
    id: 'booking',
    href: '/ordering/booking',
    title: 'Бронювання',
  },
  {
    id: 'reportsData',
    href: '/ordering/reports',
    title: 'Звіти',
  },
];
